import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white px-5 py-16 sm:px-8" data-id="element-58" data-mp="1lazcje4mzhfh">
      <div className="mx-auto w-full max-w-2xl" data-id="element-59" data-mp="1gcpdutjpdyp4">
        <h2 className="text-center text-3xl font-extrabold tracking-tight text-neutral-900 sm:text-4xl" data-id="element-60" data-mp="1ge0gur5br2f6">
          Frequently Asked <span className="text-[#6d28d9]" data-id="element-61" data-mp="2dzod9c1s5kqp">Questions</span>
        </h2>

        <div className="mt-10 overflow-hidden rounded-xl border border-neutral-200" data-id="element-62" data-mp="292edb2grlqom">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className={index > 0 ? 'border-t border-neutral-200' : ''} data-id="element-63" data-mp="1z25hhpqoq79r" data-mpi={index}>
                <h3 data-id="element-64" data-mp="skqox6rc04ti">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 bg-neutral-50 px-5 py-5 text-left transition-colors hover:bg-neutral-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#6d28d9]" data-id="element-65" data-mp="no9yu70kngds">
                    <span className="text-sm font-extrabold text-neutral-900" data-id="element-66" data-mp="ki1yho3pogfx">
                      {faq.question}
                    </span>
                    {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-[#6d28d9]" aria-hidden="true" data-id="element-67" data-mp="bhwpj9ivd9zn" /> : <PlusIcon className="h-4 w-4 shrink-0 text-[#6d28d9]" aria-hidden="true" data-id="element-68" data-mp="1sd7u76w7m6d" />}
                  </button>
                </h3>
                {isOpen && <div className="bg-white px-5 pb-5 pt-4" data-id="element-69" data-mp="3nys6u9mrn5ks">
                    <p className="text-sm leading-relaxed text-neutral-600" data-id="element-70" data-mp="1uh4c9itl6gvq">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}